import { render, staticRenderFns } from "./SiteInsurance.vue?vue&type=template&id=624a3c22&scoped=true"
var script = {}
import style0 from "./SiteInsurance.vue?vue&type=style&index=0&id=624a3c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624a3c22",
  null
  
)

export default component.exports